import type { FieldsConfig, Fields, DateRange, SelectFields } from '../definitions'

import { FIELD_TYPES } from '../constants'
const isFieldsConfig = (val: unknown): val is FieldsConfig => {
  if (!val || typeof val !== 'object') {
    return false
  }
  const config = val as FieldsConfig
  return (
    config !== null
    && typeof config === 'object'
    && !Array.isArray(config)
    && Object.keys(config).every((key) => {
      const field = config[key]
      return (
        typeof field === 'object'
        && field !== null
        && 'type' in field
        && typeof field.type === 'string'
        && ('options' in field
          ? Array.isArray(field.options)
          : true)
        && ('default' in field
          ? typeof field.default === 'string'
          : true)
        && ('label' in field
          ? typeof field.label === 'string'
          : true)
        && ('description' in field
          ? typeof field.description === 'string'
          : true)
        && ('required' in field
          ? typeof field.required === 'boolean'
          : true)
        && ('fallback' in field
          ? typeof field.fallback === 'string'
          : true)
        && ('width' in field
          ? typeof field.width === 'number'
          : true)
        && ('height' in field
          ? typeof field.height === 'number'
          : true)
      )
    })
  )
}
const isField = (field: unknown): field is Fields => {
  if (!field || typeof field !== 'object') {
    return false
  }
  const f = field as Fields
  return (
    'type' in f
    && typeof f.type === 'string'
    && ('default' in f
      ? typeof f.default === 'string'
      : true)
    && ('label' in f
      ? typeof f.label === 'string'
      : true)
    && ('required' in f
      ? typeof f.required === 'boolean'
      : true)
    && ('fallback' in f
      ? typeof f.fallback === 'string'
      : true)
  )
}
const isDateRange = (config: Fields): config is DateRange => config.type === FIELD_TYPES.dateRange
const isSelect = (config: Fields): config is SelectFields => config.type === FIELD_TYPES.select

export {
  isField,
  isFieldsConfig,
  isDateRange,
  isSelect,
}
